import { render, staticRenderFns } from "./UpdateOrgSmsNum.vue?vue&type=template&id=6dbf9f74&"
import script from "./UpdateOrgSmsNum.vue?vue&type=script&lang=js&"
export * from "./UpdateOrgSmsNum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UpdateOrgSmsNum.vue"
export default component.exports